import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import StrategicAnalystProfile from "./sections/StrategicAnalystProfile";
import EstablishedTrust from "./sections/EstablishedTrust";
import ThePowerOfWhy from "./sections/ThePowerOfWhy";
import OurEliteStandards from "./sections/OurEliteStandards";
import YourPathToPassiveIncome from "./sections/YourPathToPassiveIncome";
import VoicesOfExcellence from "./sections/VoicesOfExcellence";
import InboundEngineCallToAction from "./sections/InboundEngineCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <StrategicAnalystProfile />
      <EstablishedTrust />
      <ThePowerOfWhy />
      <OurEliteStandards />
      <YourPathToPassiveIncome />
      <VoicesOfExcellence />
      <InboundEngineCallToAction />
      <Footer />
    </div>;
}